import { CSSPropsVars } from '@/interfaces/types/CSSPropsVars';
import cn from 'classnames';
import { ReactNode } from 'react';
import styles from './badge.module.scss';

export interface BadgeProps {
    backgroundColor: string;
    text?: string;
    image: ReactNode;
    ariaLabel: string;
}

export function Badge({ backgroundColor, text, image, ariaLabel = 'Only on SiriusXM' }: BadgeProps): React.JSX.Element {
    const backgroundColorCustomProperty: CSSPropsVars = {
        '--badge-background-color': backgroundColor,
    };

    return (
        <div
            role="img"
            data-badge={text ? '_BigExclusive' : '_SmallExclusive'}
            aria-label={ariaLabel}
            className={cn(styles.wrapper, { [styles.hasText]: !!text })}
            style={backgroundColorCustomProperty}
        >
            {text && (
                <div className={styles.text} aria-hidden={true}>
                    {text}
                </div>
            )}

            <div className={text ? styles.imageSmall : styles.imageBig} aria-hidden={true}>
                {image}
            </div>
        </div>
    );
}
